import Collapse from 'components/collapse/Collapse';
import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import PhoneNumberField from 'components/forms/phoneNumberField/PhoneNumberField';
import LanguageSelectField from 'components/forms/languageSelectField/LanguageSelectField';
import { useWatch } from 'react-hook-form';
import { LanguageCodeUnderscored } from 'i18n/internationalization.types';
import { CountryCode } from 'models/Country';
import { StyledSubTitle } from './OwnerModal.styles';

const OwnerProfileFields = ({
  isEdit,
  agencyCountryCode,
}: {
  isEdit: boolean;
  agencyCountryCode?: CountryCode;
}) => {
  const { t } = useTranslation();

  const hasLinkedOwner = !!useWatch({
    name: 'linkedOwnerUid',
  });

  return (
    <fieldset disabled={hasLinkedOwner} data-testid="owner-profile-fields">
      {!isEdit && (
        <StyledSubTitle>
          {t('pageProperty.owners.modal.orCreateNewOwner')}
        </StyledSubTitle>
      )}

      <Collapse
        defaultExpanded
        label={t('pageProperty.owners.modal.ownerProfile')}
        variant="card"
      >
        <TextField
          name="owner.email"
          label={t('common.email')}
          colSmInput={8}
          colSmLabel={4}
          required
          disabled={isEdit}
        />

        <TextField
          name="owner.firstName"
          label={t('pageProperty.owners.modal.firstName')}
          colSmInput={8}
          colSmLabel={4}
        />

        <TextField
          name="owner.lastName"
          label={t('pageProperty.owners.modal.lastName')}
          colSmInput={8}
          colSmLabel={4}
        />

        <TextField
          name="owner.businessName"
          label={t('pageProperty.owners.modal.businessName')}
          colSmInput={8}
          colSmLabel={4}
        />

        <TextField
          name="owner.ccEmails"
          label={t('pageProperty.owners.modal.ccEmails')}
          colSmInput={8}
          colSmLabel={4}
          rightTooltip={t('pageProperty.owners.modal.ccEmailsTooltip')}
          placeholder={t('pageProperty.owners.modal.ccEmailsPlaceholder')}
        />

        <PhoneNumberField
          label={t('pageProperty.owners.modal.phone')}
          name="owner.phoneNumber"
          colSmInput={8}
          colSmLabel={4}
          placeholder=" "
          defaultCountryCode={agencyCountryCode}
        />

        <LanguageSelectField
          label={t('componentLead.modal.form.language')}
          name="owner.preferredLocale"
          normalizeValue
          colSmInput={8}
          colSmLabel={4}
          excludeLanguages={[
            LanguageCodeUnderscored.VI_VN,
            LanguageCodeUnderscored.KO_KR,
            LanguageCodeUnderscored.JA_JP,
            LanguageCodeUnderscored.TR_TR,
          ]}
        />
      </Collapse>
    </fieldset>
  );
};

OwnerProfileFields.defaultProps = {
  agencyCountryCode: CountryCode.US,
};

export default OwnerProfileFields;
